import { InjectionToken } from '@angular/core';
import { environment } from './../environments/environment';

export const BASE_OMS_URL = new InjectionToken('BaseOMSUrl', {
  factory: () => environment.baseOMSLink,
});

export const BASE_ICM_URL = new InjectionToken('BaseICMUrl', {
  factory: () => environment.baseICMLink,
});

export const BASE_INDI_URL = new InjectionToken('BaseIndiUrl', {
  factory: () => environment.baseIndiUrl,
});

export const BASE_FRESHDESK_URL = new InjectionToken('BaseFreshdeskUrl', {
  factory: () => environment.baseFreshdeskUrl,
});

export const FRESHDESK_SERVICE_URL = new InjectionToken('FreshdeskServiceUrl', {
  factory: () => environment.freshdeskServiceUrl,
});

export const BASE_DLCS_URL = new InjectionToken('BaseDLCSUrl', {
  factory: () => environment.baseDLCSUrl,
});

export const ORDER_HISTORY_SERVICE_URL = new InjectionToken('OrderHistoryServiceUrl', {
  factory: () => environment.orderHistoryServiceUrl,
});

export const PRODUCTS_SERVICE_URL = new InjectionToken('ProductsServiceUrl', {
  factory: () => environment.productsServiceUrl,
});

export const RETURNS_SERVICE_URL = new InjectionToken('ReturnsServiceUrl', {
  factory: () => environment.returnsServiceUrl,
});

export const RETURN_FAILURES_SERVICE_URL = new InjectionToken('ReturnFailuresServiceUrl', {
  factory: () => environment.returnFailuresServiceUrl,
});

export const DISPATCH_FAILURE_SERVICE_URL = new InjectionToken('DispatchesServiceUrl', {
  factory: () => environment.dispatchFailuresServiceUrl,
});

export const INVOICE_SEARCH_SERVICE_URL = new InjectionToken('InvoiceSearchServiceUrl', {
  factory: () => environment.invoiceSearchServiceUrl,
});

export const PAYMENT_TERMS_CHECKER_SERVICE_URL = new InjectionToken('PaymentTermsCheckerServiceUrl', {
  factory: () => environment.paymentTermsCheckerServiceUrl,
});

export const MANCOS_SERVICE_URL = new InjectionToken('MancosServiceUrl', {
  factory: () => environment.mancosServiceUrl,
});

export const SALESORDERS_SERVICE_URL = new InjectionToken('SalesordersServiceUrl', {
  factory: () => environment.salesordersServiceUrl,
});

export const SOS_EMAIL_SERVICE_URL = new InjectionToken('sosEmailServiceUrl', {
  factory: () => environment.sosEmailServiceUrl,
});

export const SHIPPING_ADDRESSES_URL = new InjectionToken('priceCheckerServiceUrl', {
  factory: () => environment.shippingAddressesUrl,
});

export const CONNECTION_STATUS_CHECK_URL = new InjectionToken('connectionStatusCheckUrl', {
  factory: () => environment.connectionStatusCheckUrl,
});

export const SCSN_CUSTOMERS_URL = new InjectionToken('scsnCustomersUrl', {
  factory: () => environment.scsnCustomersUrl,
});

export const INDI_CUSTOMERS_URL = new InjectionToken('indiCustomersUrl', {
  factory: () => environment.indiCustomersUrl,
});

export const ATP_SERVICE_URL = new InjectionToken('atpServiceUrl', {
  factory: () => environment.atpServiceUrl,
});

export const ORDER_SHIPMENT_INFO_SERVICE_URL = new InjectionToken('OrderShipmentInfoServiceUrl', {
  factory: () => environment.orderShipmentInfoServiceUrl,
});
